"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgOffline(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm14.17 6.46c0 .19-.02.37-.06.54-.76-.46-1.66-.71-2.61-.71-2.06 0-3.83 1.19-4.67 2.92h-4.09c-1.5 0-2.74-1.24-2.74-2.75 0-1.41.97-2.48 2.3-2.65v-.27c0-.97.8-1.68 1.77-1.68.45 0 .8.18 1.15.44.54-1.24 1.24-2.3 3.19-2.3 2.39 0 3.54 1.77 3.54 3.72v.26c1.24.09 2.22 1.07 2.22 2.48zm-2.2762 5.04 1.5187 1.4625-.45.45-1.4625-1.5187-1.4625 1.5188-.45-.45 1.5187-1.4626-1.5188-1.4625.45-.45 1.4626 1.5187 1.4625-1.5188.45.45zm-.3938-3.6562c-2.025 0-3.6563 1.6312-3.6563 3.6563s1.6313 3.6562 3.6563 3.6562 3.6563-1.6312 3.6563-3.6563-1.6313-3.6562-3.6563-3.6562m4.5 3.6562c0 2.475-2.025 4.5-4.5 4.5s-4.5-2.025-4.5-4.5 2.025-4.5 4.5-4.5 4.5 2.025 4.5 4.5z' })));
}
exports.default = SvgOffline;
